import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalBroadcastService,
    MsalGuard,
    MsalModule,
    MsalRedirectComponent,
    MsalService,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './msal-auth.utilities';
import { PaceMsalAuthService } from './msal-auth.service';
import { LogInstanceToken } from '@evorait/pace-logging';
import { PaceMsalOfflineCapableInterceptor } from './msal-offline-capable.interceptor';
import { PaceMsalXIdTokenInterceptor } from './msal-x-id-token.interceptor';
import { EnvironmentService } from '@evorait/pace-environment';

export function initializerFactory(env: EnvironmentService) {
    console.log('api base:', env.apiBase);
    return (): Promise<unknown> =>
        new Promise((resolve) => {
            resolve(true);
        });
}

@NgModule({
    imports: [MsalModule],
    providers: [MsalService, MsalGuard, MsalBroadcastService, PaceMsalAuthService],
    exports: [MsalModule],
    bootstrap: [MsalRedirectComponent],
})
export class PaceMsalAuthenticationModule {
    public static forRoot(): ModuleWithProviders<PaceMsalAuthenticationModule> {
        return {
            ngModule: PaceMsalAuthenticationModule,
            providers: [
                provideAppInitializer(() => {
                    const initializerFn = initializerFactory(inject(EnvironmentService));
                    return initializerFn();
                }),
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: PaceMsalOfflineCapableInterceptor,
                    multi: true,
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: PaceMsalXIdTokenInterceptor,
                    multi: true,
                },
                {
                    provide: MSAL_INSTANCE,
                    useFactory: MSALInstanceFactory,
                    deps: [LogInstanceToken, EnvironmentService],
                },
                {
                    provide: MSAL_GUARD_CONFIG,
                    useFactory: MSALGuardConfigFactory,
                    deps: [EnvironmentService],
                },
                {
                    provide: MSAL_INTERCEPTOR_CONFIG,
                    useFactory: MSALInterceptorConfigFactory,
                    deps: [EnvironmentService],
                },
            ],
        };
    }
}
